import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface PWAUpdateDialogProps {
  open: boolean;
  onClose: () => void;
  onUpdate: () => void;
}

export const PWAUpdateDialog: FC<PWAUpdateDialogProps> = ({
  open,
  onClose,
  onUpdate,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      aria-labelledby="update-dialog-title"
    >
      <DialogTitle id="update-dialog-title">
        {t('pwa.updateAvailable')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('pwa.updateMessage')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} color="primary">
          {t('common.later')}
        </Button>
        <Button 
          onClick={onUpdate} 
          color="primary" 
          variant="contained" 
          autoFocus
        >
          {t('common.updateNow')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
